import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useListMachineSanitary = () => {

    const [catMachinesSanitary, setcatMachinesSanitary] = useState([]);
    const [id_machine_sanitary, setid_machine_sanitary] = useState(0);
    const [dataDatacatMachinesSanitarySearch, setDatacatMachinesSanitarySearch] = useState([]);

  
    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle,setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const history = useHistory();

    const [formValues,handleInputChange, reset, handleUpdateValues,] = useForm({
        descripcion:"",
        clave:"",
    });
    const [validaciones, setValidaciones] = useState({
        descripcion_valid:false,
    })
    const {descripcion,clave } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(catMachinesSanitary.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listcatMachinesSanitary = [];
        catMachinesSanitary.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcatMachinesSanitary.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setcatMachinesSanitary(listcatMachinesSanitary);
    }, [totalPageCount, currentPage])

    const toggle = ()=>{
        setModal(!modal);
    }
   
    useEffect(()=>{
        getSample();
    },[history.location]);


    const getSample = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "CatMachineSanitary/List");

        if (respuesta.code === 200) {
            let listcatMachinesSanitary= [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                listcatMachinesSanitary.push({
                        id_machine_sanitary: data.id_machine_sanitary,
                        descripcion: data.descripcion,
                        clave: data.clave
                    });
                });
                setcatMachinesSanitary(listcatMachinesSanitary);
                setDatacatMachinesSanitarySearch(listcatMachinesSanitary);
            }
        }
    }

    
    const handleCreate = () => {
        handleUpdateValues({
            descripcion: "",
            clave: "",
        });

        setValidaciones({
            descripcion_valid: false,
        });

        setid_machine_sanitary(0);
        setMethod("create");
        setModalTitle("Crear un nuevo Equipo/Consumible");
        toggle();
    }   

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "CatMachineSanitary/Create");
        if (respuesta.code === 200) {
            getSample();
            createSweet("create", "success", "Éxito!", "Creado con éxito");
            setLoading(false);
            toggle();
        }
    }

    const handleUpdate = (id_machine_sanitary) => {
        let catMachinesSanitarytemp = catMachinesSanitary.find(s => s.id_machine_sanitary === id_machine_sanitary);

        handleUpdateValues({
            descripcion: catMachinesSanitarytemp.descripcion,
            clave: catMachinesSanitarytemp.clave,
        });

        setValidaciones({
            descripcion_valid: false,
        });

        setid_machine_sanitary(id_machine_sanitary);
        setMethod("update");
        setModalTitle("Modificación de Equipo/Consumible");
        toggle();
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_machine_sanitary: id_machine_sanitary,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);
        
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "CatMachineSanitary/Update");

        if (respuesta.code === 200) {
            getSample();
            createSweet("create", "info", "Exito!", "Equipo/Consumible actualizada");
            setLoading(false);
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }

    const handleDelete = (id_machine_sanitary) => {
        
        let catMachinesSanitarytemp = catMachinesSanitary.find(s => s.id_machine_sanitary === id_machine_sanitary);

        handleUpdateValues({
            descripcion: catMachinesSanitarytemp.descripcion,
            clave: catMachinesSanitarytemp.clave,
        });

        setid_machine_sanitary(id_machine_sanitary);
        setMethod("delete");
        setModalTitle("eliminar");
        toggle();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `CatMachineSanitary/${id_machine_sanitary}`);

        if (respuesta.code === 200) {
            getSample();
            setLoading(false);
            createSweet("create", "info", "Exito!", "Equipo/Consumible eliminado");
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
       

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name === "" || formValues.descripcion.length < 3) {
            newValidations = {
                ...newValidations,
                descripcion_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                descripcion_valid: false
            }
        }
        setValidaciones(newValidations);

        return statusValidation;
    }

    const handleSearchSample = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        dataDatacatMachinesSanitarySearch.forEach(element => {            

            let cadena = element.descripcion.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setcatMachinesSanitary(newMethod);
    }

    return {
        catMachinesSanitary, descripcion,clave, validaciones,
        method, 
        handleInputChange, handleSearchSample, loading, 
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
    }

}




